// assets/product-state-manager.js

(function() {
  'use strict';
  
  // Initialize global product state
  window.ProductState = {
    // Core product data (will be set by liquid template)
    productData: null,
    allDesigns: {},
    allPromoters: [],
    allSerotypes: [],
    allBackbones: {},
    
    // Current selections
    variant: null,
    design: null,
    promoter: null,
    serotype: null,
    backbone: null,
    
    // Getters
    get currentVariant() {
      return this.variant;
    },
    
    get currentDesign() {
      return this.design;
    },
    
    get currentPromoter() {
      return this.promoter;
    },
    
    get currentSerotype() {
      return this.serotype;
    },
    
    get currentBackbone() {
      return this.backbone;
    },
    
    // Setters with change notifications
    setVariant: function(variantId) {
      if (!this.productData) {
        console.warn('ProductState: productData not initialized');
        return;
      }
      
      var variant = this.productData.variants.find(function(v) {
        return v.id === variantId;
      });
      
      if (variant && (!this.variant || this.variant.id !== variantId)) {
        this.variant = variant;
        
        // Detect which option holds the design name by matching against known designs
        var allDesignNames = Object.keys(this.allDesigns);
        var detectedDesign = [variant.option1, variant.option2, variant.option3].find(function(opt) {
          return opt && allDesignNames.indexOf(opt) !== -1;
        });
        
        // Fall back to option1 if no match (allDesigns may not be populated yet)
        this.design = detectedDesign || variant.option1;
        
        this.notifyChange('variant', variant);
        this.notifyChange('design', this.design);
      }
    },
    
    setPromoter: function(name, length) {
      if (!this.promoter || this.promoter.name !== name) {
        this.promoter = { name: name, length: length };
        this.notifyChange('promoter', this.promoter);
      }
    },
    
    setSerotype: function(name) {
      if (this.serotype !== name) {
        this.serotype = name;
        this.notifyChange('serotype', name);
      }
    },
    
    setBackbone: function(backboneName) {
      var backboneData = this.allBackbones[backboneName];
      if (backboneData && (!this.backbone || this.backbone.name !== backboneName)) {
        this.backbone = backboneData;
        this.notifyChange('backbone', backboneData);
      }
    },
    
    setProductData: function(data) {
      this.productData = data;
      
      if (data.metafields && data.metafields.custom && data.metafields.custom.backbone) {
        this.backbone = data.metafields.custom.backbone;
        this.notifyChange('backbone', this.backbone);
      }
    },
    
    setDesigns: function(designs) {
      this.allDesigns = designs;
      
      // Re-resolve design now that we have the full design list,
      // in case setVariant ran before setDesigns populated allDesigns
      if (this.variant) {
        var allDesignNames = Object.keys(designs);
        var detectedDesign = [this.variant.option1, this.variant.option2, this.variant.option3].find(function(opt) {
          return opt && allDesignNames.indexOf(opt) !== -1;
        });
        if (detectedDesign && detectedDesign !== this.design) {
          this.design = detectedDesign;
          this.notifyChange('design', this.design);
        }
      }
    },
    
    setPromoters: function(promoters) {
      this.allPromoters = promoters;
      this.notifyChange('promoters', promoters);
    },
    
    setSerotypes: function(serotypes) {
      this.allSerotypes = serotypes;
    },
    
    setBackbones: function(backbones) {
      this.allBackbones = backbones;
    },
    
    // Change notification system
    listeners: {},
    
    onChange: function(key, callback) {
      if (!this.listeners[key]) {
        this.listeners[key] = [];
      }
      this.listeners[key].push(callback);
    },
    
    notifyChange: function(key, value) {
      if (this.listeners[key]) {
        this.listeners[key].forEach(function(callback) {
          callback(value);
        });
      }
    },
    
    // Initialization
    init: function() {
      this.initializeVariant();
      this.watchVariantChanges();
    },
    
    initializeVariant: function() {
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');
      
      if (variantId) {
        this.setVariant(parseInt(variantId));
        return;
      }
      
      if (this.productData && this.productData.variants.length > 0) {
        this.setVariant(this.productData.variants[0].id);
      }
    },
    
    watchVariantChanges: function() {
      var self = this;
      
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            var input = mutation.target;
            var newVariantId = parseInt(input.value);
            if (newVariantId && !isNaN(newVariantId)) {
              self.setVariant(newVariantId);
            }
          }
        });
      });
      
      var checkInterval = setInterval(function() {
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
          clearInterval(checkInterval);
          
          var initialId = parseInt(variantInput.value);
          if (initialId && !isNaN(initialId)) {
            self.setVariant(initialId);
          }
          
          observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      }, 100);
      
      setTimeout(function() {
        clearInterval(checkInterval);
      }, 5000);
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.ProductState.init();
    });
  } else {
    window.ProductState.init();
  }
})();